import React, { Fragment } from "react";
import { Link, useNavigate } from "react-router-dom";
import { isAuth, signout } from "../auth/helpers";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import SidebarAdmin from "../components/Sidebar/SidebarAdmin";
import routes from "../adminRoutes.js";
import logo from "../assets/img/smartpart.png";
import bgImage from "../assets/img/sidebar-2.jpg";
import Grid from "@mui/material/Grid";
import GridItem from "../components/Grid/GridItem";
import resources from "../core//Localization/Localization.js";
import { ToastContainer } from "react-toastify";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import LanguageIcon from "@mui/icons-material/Language";
import Button from "../components/CustomButtons/Button";
import AddIcon from "@mui/icons-material/Add";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { primaryColor } from "../assets/jss/material-dashboard-react";
import { Box, useTheme } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useMediaQuery } from "@mui/material";
import { setOpenDrawer } from "../reduxStore/entities/dashboard";
import { getSxStyle } from "../utils/getSxStyle.js";

const drawerWidth = 240;

const useStyles = (theme) => ({
    root: {
        display: "flex",
        justifyContent: "flex-end",
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerContainer: {
        overflow: "auto",
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    container: {
        marginTop: 20,
    },
    iconStyle: {
        cursor: "pointer",
    },
    addButton: {
        position: "fixed",
        bottom: 5,
        right: 10,
    },
});

const Layout = ({ children, showAddButton, onAdd }) => {
    const theme = useTheme();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const matches = useMediaQuery(theme.breakpoints.down("xs"));
    const openDrawer = useSelector((state) => state.dashboard.openDrawer);

    const isActive = (path) => {
        return { color: window.location.pathname === path ? "#000" : "#fff" };
    };

    const setActiveLang = (val) => {
        return resources.getLanguage() === val ? { color: primaryColor[0] } : { color: "#fff" };
    };

    const changeLanguage = (lng) => {
        resources.setLanguage(lng);
    };

    const handleDrawerToggle = () => {
        dispatch(setOpenDrawer(!openDrawer));
    };

    React.useEffect(() => {
        if (matches && openDrawer) {
            handleDrawerToggle();
        }
    }, [matches, openDrawer]);

    const nav = () => (
        <AppBar position="static" color="primary" sx={(theme) => getSxStyle(theme, useStyles, ['root'])}>
            <Toolbar variant="regular" disableGutters>
                <Box className="nav-link" onClick={handleDrawerToggle}>
                    {openDrawer ? <MenuOpenIcon sx={(theme) => getSxStyle(theme, useStyles, ['iconStyle'])} /> : <MenuIcon sx={(theme) => getSxStyle(theme, useStyles, ['iconStyle'])} />}
                </Box>

                <Grid justifyContent="flex-end" alignItems="center" wrap="nowrap" container spacing={0}>
                    <GridItem>
                        <Link className="nav-link" onClick={() => changeLanguage("en")} to="/" style={setActiveLang("en")}>
                            <LanguageIcon sx={(theme) => getSxStyle(theme, useStyles, ['iconStyle'])} />
                            EN
                        </Link>
                    </GridItem>

                    <GridItem>
                        <Link className="nav-link" onClick={() => changeLanguage("rs")} to="/" style={setActiveLang("rs")}>
                            <LanguageIcon sx={(theme) => getSxStyle(theme, useStyles, ['iconStyle'])} />
                            RS
                        </Link>
                    </GridItem>

                    <GridItem>
                        <Link className="nav-link" style={isActive("/profile")} to="/profile">
                            <PermIdentityOutlinedIcon sx={(theme) => getSxStyle(theme, useStyles, ['iconStyle'])} />
                            {isAuth().firstname}
                        </Link>
                    </GridItem>

                    {isAuth() && (
                        <GridItem>
                            <span
                                style={{ cursor: "pointer", color: "#fff" }}
                                onClick={() => {
                                    signout(() => {
                                        navigate("/signin");
                                    });
                                }}
                            >
                                <ExitToAppIcon sx={(theme) => getSxStyle(theme, useStyles, ['iconStyle'])} />
                                {matches ? "" : resources.signout}
                            </span>
                        </GridItem>
                    )}
                </Grid>
            </Toolbar>
        </AppBar>
    );

    return (
        <Fragment>
            <SidebarAdmin
                routes={routes}
                logoText={"Dashboard"}
                logo={logo}
                image={bgImage}
                open={openDrawer}
                color={"purple"}
                font={"darkFont"}
                handleDrawerToggle={handleDrawerToggle}
            />
            <div className="panel-container" style={openDrawer ? { marginLeft: 260 } : { marginLeft: 0 }}>
                {nav()}
                <ToastContainer />
                <div className={"panel"}>{children}</div>
            </div>

            {showAddButton && (
                <Button
                    sx={(theme) => getSxStyle(theme, useStyles, ['addButton'])}
                    size={"lg"}
                    color={"info"}
                    type={"button"}
                    justIcon={true}
                    round={true}
                    onClick={onAdd ? onAdd : null}
                >
                    <AddIcon />
                </Button>
            )}
        </Fragment>
    );
};

export default Layout;
